var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B7A7F"
    },
    d: "M512,306.087v11.13c0,9.22-7.475,16.696-16.696,16.696H16.696C7.475,333.913,0,326.438,0,317.217 v-11.13c0-9.22,7.475-16.696,16.696-16.696h478.609C504.525,289.391,512,296.866,512,306.087z M201.045,152.33l110.881-9.7 l-2.911-33.264c-1.072-12.247-11.868-21.307-24.116-20.236l-66.529,5.82c-12.248,1.072-21.307,11.868-20.236,24.116L201.045,152.33z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#769CA5"
    },
    d: "M442.77,280.476l-11.795,117.949c-4.552,45.519-42.855,80.184-88.602,80.184H169.627 c-45.746,0-84.049-34.665-88.602-80.184L69.23,280.476C67.92,267.371,78.21,256,91.381,256h329.238 C433.79,256,444.08,267.371,442.77,280.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90B5BF"
    },
    d: "M442.77,280.476l-11.795,117.949c-4.552,45.519-42.855,80.184-88.602,80.184h-70.238 c-45.746,0-84.049-34.665-88.602-80.184l-11.795-117.949c-1.31-13.105,8.98-24.476,22.151-24.476h226.729 C433.79,256,444.08,267.371,442.77,280.476z M457.525,146.651c-1.339-15.31-14.836-26.635-30.146-25.295L83.65,151.428 c-15.31,1.34-26.634,14.836-25.295,30.146l0,0c1.339,15.309,14.836,26.634,30.145,25.295l343.731-30.072 C447.54,175.457,458.864,161.96,457.525,146.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#769CA5"
    },
    d: "M457.525,146.651c1.339,15.31-9.985,28.806-25.295,30.146L88.5,206.869 c-15.31,1.339-28.806-9.985-30.146-25.295l0,0c-0.536-6.136,0.965-11.979,3.938-16.867c5.328,8.755,15.305,14.226,26.208,13.272 l343.73-30.072c9.174-0.802,16.912-5.973,21.357-13.279C455.742,138.169,457.14,142.242,457.525,146.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA233"
    },
    d: "M367.304,244.87c6.147,0,11.13,4.983,11.13,11.13v89.043c0,12.564-10.408,22.697-23.072,22.246 c-12.063-0.429-21.449-10.71-21.449-22.78v-13.599c-3.861,2.236-8.44,3.37-13.325,2.895c-11.484-1.118-20.066-11.122-20.066-22.66 V256c0-6.147,4.983-11.13,11.13-11.13h22.261h11.13H367.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC248"
    },
    d: "M356.174,311.652L356.174,311.652c-12.295,0-22.261-9.966-22.261-22.261V244.87h33.391 c6.147,0,11.13,4.983,11.13,11.13v33.391C378.435,301.686,368.469,311.652,356.174,311.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B7A7F"
    },
    d: "M464.696,503.652c0,4.61-3.738,8.348-8.348,8.348H44.522c-4.61,0-8.348-3.738-8.348-8.348 s3.738-8.348,8.348-8.348h411.826C460.958,495.304,464.696,499.042,464.696,503.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC248"
    },
    d: "M364.522,8.348v77.913c0,4.61-3.736,8.348-8.348,8.348c-4.611,0-8.348-3.738-8.348-8.348V8.348 c0-4.61,3.736-8.348,8.348-8.348C360.785,0,364.522,3.738,364.522,8.348z M389.565,0c-4.611,0-8.348,3.738-8.348,8.348v77.913 c0,4.61,3.736,8.348,8.348,8.348c4.611,0,8.348-3.738,8.348-8.348V8.348C397.913,3.738,394.177,0,389.565,0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.08af29d009c418acc2cee0cd8114110d.svg";
export { ForwardRef as ReactComponent };